export default "__VITE_ASSET__Bi_WBMmn__"